import { render, staticRenderFns } from "./Screening3.vue?vue&type=template&id=a1d8fd98&"
import script from "./Screening3.vue?vue&type=script&lang=js&"
export * from "./Screening3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports